import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { WelcomeComponent } from '_welcome/welcome/welcome.component';
import { SchoolNotFoundComponent } from '_welcome/school-not-found/school-not-found.component';
import { StatusComponent } from '_welcome/status/status.component';
import { NpcRootComponent } from '_welcome/npc-root/npc-root.component';
import { ResumeComponent } from '_welcome/resume/resume.component';
import { InstantEstimatePageComponent } from './_instant-estimate/instant-estimate-page.component';
import { AuthGuard } from './_services/auth.guard';

export const routes: Routes = [
  {
    path: 'app',
    canActivate: [AuthGuard],
    children: [
      // Instant estimate POC — must be before calculator :schoolId children
      { path: ':schoolId/instant-estimate', component: InstantEstimatePageComponent },
      // Main entry - Just the school, no session
      { path: ':schoolId', component: WelcomeComponent, data: { showFooter: true, animation: { value: 'welcome', } } },
      // Path for no school entered
      { path: '', pathMatch: 'full', component: SchoolNotFoundComponent },
      // College Board login return — claim the pending snapshot, then navigate on.
      // Must precede the calculator route so the 3-segment URL isn't swallowed by it.
      { path: ':schoolId/resume/:pendingSessionId', component: ResumeComponent },
      { path: ':schoolId', loadChildren: () => import('./_calculator/calculator.module').then(m => m.CalculatorModule), data: { shell: 'calculator' } }
    ]
  },
  // { path: '', loadChildren: './_calculator/calculator.module#CalculatorModule' },
  { path: 'status', component: StatusComponent },
  { path: '**', component: NpcRootComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
